/**
 * Format message with console-style format specifiers
 * Supports: %s, %d, %i, %f, %o, %O, %c
 *
 * @param {Array} args - Array of arguments from console call
 * @returns {string} - Formatted message string
 */
import { valueToLogString } from './serializeLogValue.js'

export function formatMessage(args) {
  if (!args || args.length === 0) return ''

  const firstArg = args[0]
  const formatString = typeof firstArg === 'string' ? firstArg : ''
  const values = args.slice(1)

  // If no format specifiers, handle objects like native console
  if (!formatString.includes('%')) {
    // If first arg is null, treat it as a value
    if (firstArg === null) {
      const allValues = [firstArg, ...values]
      return allValues.map(valueToLogString).join(' ')
    }

    // If first arg is an object, treat it as a value
    if (typeof firstArg === 'object' && firstArg !== null) {
      const allValues = [firstArg, ...values]
      return allValues.map(valueToLogString).join(' ')
    }

    // Otherwise handle normal case (e.g. "message", error)
    if (values.length > 0) {
      return formatString + ' ' + values.map(valueToLogString).join(' ')
    }
    return formatString
  }

  let result = formatString
  let valueIndex = 0

  // Handle different format specifiers
  const formatSpecifiers = [
    { pattern: /%s/g, formatter: (value) => String(value) },
    { pattern: /%d|%i/g, formatter: (value) => parseInt(value, 10) },
    { pattern: /%f/g, formatter: (value) => parseFloat(value) },
    { pattern: /%o/g, formatter: (value) => valueToLogString(value) },
    { pattern: /%O/g, formatter: (value) => valueToLogString(value) },
    { pattern: /%c/g, formatter: (value) => `[CSS: ${value}]` }, // CSS styling not supported in logs
  ]

  // Process each format specifier
  for (const specifier of formatSpecifiers) {
    result = result.replace(specifier.pattern, (match) => {
      if (valueIndex < values.length) {
        const value = values[valueIndex]
        valueIndex++
        return specifier.formatter(value)
      }
      return match // Keep original if no more values
    })
  }

  return result
}

export default formatMessage
